import {Occupation} from '@/js/util/member/formUserInputOptionConstants'
/**
 * 住宅ローン・家賃のお支払いの変換処理
 * @param {string} val
 * @returns
 */
export const adjustLoanRent = (val) => {
  if (val) {
    return val === '0' ? '支払いなし' : '支払いあり'
  } else {
    return null
  }
}

/**
 * 給料日の表示変換処理
 * @param {numberr} val
 * @returns
 */
export const adjustPayDay = (val) => {
  if (val) {
    let result
    switch (val) {
      case 32:
        result = '日払い'
        break
      case 33:
        result = '週払い'
        break
      default:
        result = val
        break
    }
    return result
  } else {
    return null
  }
}

/**
 * お勤め先・学校についての変換処理
 * @param {string} val
 * @param {string} hasPayment
 * @returns
 */
export const adjustOccupation = (val, hasPayment) => {
  // 選択肢を取得
  const OccupationOptionConstants = Occupation[hasPayment] ?? []
  // 選択肢からvalを検索
  const matchOccupation = OccupationOptionConstants.find((v) => v.value === val)

  return matchOccupation ? matchOccupation.value : null
}
